module.exports = "uniform sampler2D uGridTexture;\n\nvarying vec3 vColor;\nvarying float vAlpha;\n\nvoid main()\n{\n    gl_FragColor = vec4(vColor, vAlpha);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/shaders/barrel.fragment.glsl
// module id = WxcZ
// module chunks = 1